import JobModel from '@/common/models/jobs/job-model';
import timezone from '@/common/timezone';

export default class FrontendJobModel extends JobModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        const {
            items = null,
            ids = [],
            api,
        } = fields;
        this.location = JobModel.Locations.frontend;
        this.api = api;
        this.items = items || ids.map(id => ({
            id,
            status: FrontendJobModel.ItemStatuses.pending,
        }));
    }

    static ItemStatuses = {
        pending: 'pending',
        completed: 'completed',
        failed: 'failed',
        invalid: 'invalid',
    }

    get isCompleted() {
        return !(this.items
            .filter(item => item.status === FrontendJobModel.ItemStatuses.pending)
            .length);
    }

    get completedItems() {
        return this.items.filter(item => item.status === FrontendJobModel.ItemStatuses.completed);
    }

    get failedItems() {
        return this.items.filter(item => item.status === FrontendJobModel.ItemStatuses.failed);
    }

    get invalidItems() {
        return this.items.filter(item => item.status === FrontendJobModel.ItemStatuses.invalid);
    }

    async start() {
        this.processedOn = timezone.now();
        await this.verifyItemStatus();
        const actions = this.items
            .filter(item => ![FrontendJobModel.ItemStatuses.completed,
                FrontendJobModel.ItemStatuses.invalid].includes(item.status))
            .map(async (item) => {
                const success = await this.performAction(item);
                item.status = FrontendJobModel.ItemStatuses[success ? 'completed' : 'failed'];
            });
        await Promise.all(actions);
    }

    // Functions that should be implemented on descendant class

    // The action to be performed on each individual item
    // Typically one or two API calls
    // eslint-disable-next-line class-methods-use-this
    performAction() {
        throw new Error('This method is not implemented on abstract class');
    }

    // This method verifies the status of each item.
    // Eg. Making a getAll request and setting the status of each item accordingly
    // eslint-disable-next-line class-methods-use-this
    verifyItemStatus() {
        throw new Error('This method is not implemented on abstract class');
    }

    getPayload() {
        return {
            ...super.getPayload(),
            api: this.api,
            items: this.items,
        };
    }
}
